import { EntityRatingComment, EntityRatingCommentByIdDocument } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export async function getEntityRatingCommentByIdService(id: string): Promise<EntityRatingComment | null | undefined> {
  const { data } = await ApolloClient.query({
    query: EntityRatingCommentByIdDocument,
    variables: { id },
  });

  return data?.entityRatingCommentById;
}
